import React, { ComponentProps, useMemo, useState } from 'react';
import { PurchaseOrderDocument } from '../../graphql/entities';

import PurchaseOrderWorkspace from '../../views/purchases/PurchaseOrderWorkspace';
import PurchaseOrderDocumentWorkspace from '../../views/purchases/PurchaseOrderDocumentWorkspace';
import { InclusionMethod, WorkspaceDocumentPrintHeader } from './DocumentPrintHeader';
import { FilterOperation, IFilterInput } from '../../graphql/schema/p4types';

const columnOverrides = {
  'supplier.supplierPurchaseOrderDocumentDefault.output': {
    name: 'Output',
  },
};

const PurchaseOrderPrintForm = ({
  inclusionMethodOptions,
  predefinedFilters,
  onClose,
}: {
  inclusionMethodOptions?: ComponentProps<typeof WorkspaceDocumentPrintHeader>['inclusionMethodOptions'];
  predefinedFilters?: Array<IFilterInput>;
  onClose?: () => void;
}) => {
  const [purchaseOrderInclusionMethod, setPurchaseOrderInclusionMethod] = useState(InclusionMethod.New);

  const purchaseOrderPredefinedFilters = useMemo(() => {
    if (predefinedFilters) {
      return predefinedFilters;
    }
    const newPurchaseOrderPredefinedFilters: Array<IFilterInput> = [
      {
        filterOperation: FilterOperation.Equals,
        filterParameters: {
          field: 'purchaseOrderDocumentRequired',
          value: 'true',
        },
      },
    ];
    if (purchaseOrderInclusionMethod !== InclusionMethod.NewAndAmended) {
      newPurchaseOrderPredefinedFilters.push({
        filterOperation: FilterOperation.Equals,
        filterParameters: {
          field: 'purchaseOrderDocumentPrinted',
          value: `${purchaseOrderInclusionMethod === InclusionMethod.Amended}`,
        },
      });
    }
    return newPurchaseOrderPredefinedFilters;
  }, [predefinedFilters, purchaseOrderInclusionMethod]);

  const printHeader = (
    <WorkspaceDocumentPrintHeader
      inclusionMethod={purchaseOrderInclusionMethod}
      setInclusionMethod={setPurchaseOrderInclusionMethod}
      actionFieldNames={{
        new: 'purchaseOrders',
        reprint: 'purchaseOrderDocuments',
      }}
      actionViewNames={{
        new: '/purchasing/Workspace',
        reprint: '/purchasing/PurchaseOrders/Workspace',
      }}
      entity={PurchaseOrderDocument}
      customBreadcrumb={[{ path: '/menu/Purchasing', title: 'Purchasing' }]}
      inclusionMethodOptions={inclusionMethodOptions}
      onClose={onClose}
    />
  );

  return purchaseOrderInclusionMethod !== 'REPRINT' ? (
    <PurchaseOrderWorkspace
      embeddedView={true}
      viewScreenName="/purchasing/Workspace"
      predefinedFilters={purchaseOrderPredefinedFilters}
      enableRowSelect={true}
      fieldNames={['supplier.supplierPurchaseOrderDocumentDefault.output']}
      columnOverrides={columnOverrides}
      customHeader={printHeader}
      ignoreContainerWidth={true}
    />
  ) : (
    <PurchaseOrderDocumentWorkspace
      embeddedView={true}
      viewScreenName="/purchasing/PurchaseOrders/Workspace"
      enableRowSelect={true}
      customHeader={printHeader}
      ignoreContainerWidth={true}
    />
  );
};

export default PurchaseOrderPrintForm;
